<template #action>
  <div class="flex justify-end my-2">
    <aha-antd-button
      v-aha-emit-action
      name="slide-copy-button"
      @click="handleCopyButtonClick()"
      :disabled="!selectedPresentationId"
      :submitting="isSlideCopying"
      is-loading-inline
    >
      <span>{{ $i18nPresenter.t('Copy') }}</span>
    </aha-antd-button>
  </div>
</template>

<script>
export default {
  props: {
    selectedPresentationId: {
      type: Number,
      default: null,
    },
    isSlideCopying: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCopyButtonClick() {
      this.$emit('handleCopyButtonClick')
    },
  },
}
</script>
